<template>
  <div class="banners column">
    <draggable v-model="campoBanner.value">
      <div class="banner column p-2 mb-4" v-for="(banner,ii) in campoBanner.value" :key="banner.id">
        <div class="imagem row mx-0 mb-2">
          <span class="index row col-12 d-center m-0 p-0 mb-2">
            <span class="d-center">{{ii+1}}</span>
          </span>
          <div class="imgSize m-2" v-for="(img,imgk) in banner.imagens" :key="'img_'+imgk">
            <div
              class="imgCase column d-flex align-items-center justify-content-center"
              :data-size="img._defs.local"
              :data-sugestao="'Sugerido: '+img._defs.info"
              :class="{excluindo:img._defs.excluir,clickable:!img.url}"
              @click="modalEnvio(img,imgk)"
            >
              <template v-if="img.url">
                <img :src="imgCDN(img.url)" />
                <div class="btnExcluir row clickable m-0">
                  <span
                    v-if="!img._defs.excluir"
                    @click="img._defs.excluir = true"
                    class="excluirImagem fas fa-times d-center"
                  ></span>
                  <template v-else>
                    <span @click="img._defs.excluir = false" class="fas fa-arrow-left d-center mr-1"></span>
                    <span @click="confirmarRemocao(img)" class="fas fa-check d-center"></span>
                  </template>
                </div>
              </template>
              <template v-else>Enviar imagem</template>
            </div>
          </div>
        </div>

        <div class="row">
          <base-input class="col-4 mb-2" label="Ação">
            <multiselect
              v-model="banner.acao"
              track-by="valor"
              label="nome"
              :options="campoBanner.opcoes"
              :searchable="false"
              placeholder="Selecione"
              selectLabel="Selecionar"
              selectedLabel="Atual"
              deselectLabel="Remover"
              @select="banner.alvo = null"
            ></multiselect>
          </base-input>

          <base-input class="col-8 mb-2" label="Alvo">
            <multiselect
              v-if="banner.acao && banner.acao.valor && (banner.acao.valor.toString() in campoBanner.opcoesAcao)"
              v-model="banner.alvo"
              track-by="id"
              label="nome"
              :options="campoBanner.opcoesAcao[banner.acao.valor]"
              :multiple="banner.acao.multi ? banner.acao.multi : false"
              placeholder="Selecione"
              selectLabel="Selecionar"
              selectedLabel="Atual"
              deselectLabel="Remover"
            >
              <span slot="noResult">Nada encontrado</span>
            </multiselect>
          </base-input>
        </div>
        <div class="row justify-content-end m-0">
          <base-button
            v-if="campoBanner.value.length > 1"
            type="default"
            icon="fas fa-times"
            size="sm"
            class="self-align-end"
            @click="removerBanner(ii)"
          >REMOVER</base-button>
        </div>
      </div>
    </draggable>

    <div class="d-center">
      <base-button @click="novoBanner(campoBanner)" outline>Adicionar outro banner</base-button>
    </div>

    <modal :show.sync="enviar.aberto">
      <h6 slot="header" class="modal-title" id="modal-title-default">Enviar imagem</h6>

      <div class="row">
        <file-pond
          :name="'banner-'+enviar.largura"
          ref="pond"
          class="col-12 clickable"
          class-name="my-pond"
          label-idle="Solte aqui ou clique"
          allow-multiple="false"
          accepted-file-types="image/jpeg, image/png"
          v-bind:files="enviar.arquivos"
          :server="uploadPoint"
          @processfile="processar"
          :allowImageValidateSize="true"
        />
      </div>

      <template slot="footer">
        <base-button type="live-dark" @click="enviar.aberto = false">Cancelar</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import config from "config";
import storage from "storage";
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";


// Para o envio de arquivos:
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";
import FilePondPluginImageValidateSize from "filepond-plugin-image-validate-size";
import "filepond/dist/filepond.min.css";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImageValidateSize
);
// Fim

export default {
  components: {
    FilePond,
    Multiselect,
    draggable,
  },
  name: "banner-editor",
  props: {
    campoBanner: {
      type: Object,
      description: "Objeto do campo banner com todos os seus detalhes",
    },
    modal: {
      type: Object,
      description: "Objeto do modal de envios",
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur,
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners,
      };
    },
  },
  methods: {
      novoBanner: function (local) {
      local.value.push(local.modelo);
    },
    removerBanner: function (idx) {
      this.campoBanner.value.splice(idx, 1);
    },
    imgCDN: function (url) {
      return config.app.imgCDN + "app-experience/banner/" + url;
    },
    modalEnvio: function (img, tamanho) {
      if (img.url) return false; // Não abrir o modal de envio se este item já tiver imagem

      this.enviar.arquivos = [];
      this.enviar.aberto = true;
      this.enviar.largura = tamanho;
      this.enviar.alvo = img;
    },
    confirmarRemocao(idxAlvo) {
      idxAlvo._defs.excluir = false;
      idxAlvo.url = "";
    },
    processar: function (error, f) {
      if (error) {
        //do ?
      } else {
        this.enviar.aberto = false;
        this.enviar.alvo.url = JSON.parse(f.serverId);
        this.enviar.alvo = null;
      }
    },
  },
  data() {
    return {
      focused: false,
      enviar: {
        aberto: false,
        alvo: null,
        arquivos: [],
        largura: 0,
      },
      uploadPoint:
        config.api.endpoint +
        "/feed-admin/upload?token=" +
        storage.get("user", "token"),
    };
  },
  mounted() {},
  beforeDestroy() {},
};
</script>
<style>
.banners .imagem {
  width: 100%;
}
.banners .banner {
  border-radius: 5px;
  transition: background-color 0.2s;
}
.banners .banner:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.banners .imagem .index {
  width: 25px;
}
.banners .imagem .index span {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.banners .imagem .index::after {
  content: "";
  background-color: rgba(0, 0, 0, 0.15);
  height: 1px;
  flex-grow: 1;
}
.banners .imagem .imgSize {
  flex-grow: 1;
  width: 200px;
}
.banners .imagem .imgCase {
  width: 100%;
  height: 150px;
  background: rgba(0, 0, 0, 0.1);
  position: relative;
  border-bottom: 2px solid #777777;
  user-select: none;
  transition: border-color 0.2s;
}
.banners .imagem .imgCase img {
  max-width: 100%;
  max-height: 100%;
}
.banners .imagem .imgCase .btnExcluir {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  color: #fff;
  background: #ff3366;
  height: 25px;
  border-radius: 50px;
  transition: 0.2s;
  transform: translate3d(0, -50%, 0);
  opacity: 0;
  pointer-events: none;
  font-size: 12px;
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.35);
}
.banners .imagem .imgCase .btnExcluir > * {
  width: 25px;
  height: 25px;
  border-radius: 50px;
}
.banners .imagem .imgCase:hover .btnExcluir,
.banners .imagem .imgCase.excluindo .btnExcluir {
  transform: translate3d(0, 0, 0);
  opacity: 1;
  pointer-events: auto;
}
.banners .imagem .imgCase::before,
.banners .imagem .imgCase::after {
  content: attr(data-size);
  position: absolute;
  bottom: -1px;
  /* left: 50%; */
  transform: scale(1) translate(0, 50%);
  z-index: 3;
  padding: 2px 4px;
  background: #777777;
  color: #fff;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: background-color 0.2s, transform 0.2s;
}
.banners .imagem .imgCase::after {
  content: attr(data-sugestao);
  transform: scale(0) translate(0, 50%);
}
.banners .imagem .imgCase:hover::after {
  transform: scale(1) translate(0, 50%);
}
.banners .imagem .imgCase:hover::before {
  transform: scale(0) translate(0, 50%);
}
.banners .imagem .imgCase.excluindo {
  outline: 2px solid #ff3366;
}

.banners .banner:hover .imagem .imgCase {
  border-color: #ff3366;
}
.banners .banner:hover .imagem .imgCase::before,
.banners .banner:hover .imagem .imgCase::after {
  background-color: #ff3366;
}
</style>